import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { PageShell } from '../components/site/PageParts';
import useSeo from '../hooks/useSeo';

export default function ThankYou() {
  const { state } = useLocation();
  useSeo({ title: 'Thank You | Pusha Teez', description: 'Your quote request was received.', path: '/thank-you', noindex: true });
  const first = state?.name?.trim().split(' ')[0];
  return (
    <PageShell testid="thank-you-page">
      <section className="px-6 py-24 md:py-36">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 rounded-full bg-[#00b8ff]/15 text-[#00b8ff] flex items-center justify-center mx-auto mb-8">
            <CheckCircle2 className="w-8 h-8" />
          </div>
          <h1 className="font-display text-[#f4efe6] uppercase text-5xl md:text-7xl tracking-tight">
            Thank <span className="font-script italic text-[#00b8ff] normal-case">you{first ? `, ${first}` : ''}</span>
          </h1>
          <p className="text-[#cfc8bb] text-base md:text-lg mt-6" data-testid="thank-you-message">
            We received your {state?.isEvent ? 'live event' : 'production'} quote request and will reply within one business day
            {state?.email ? <> at <span className="text-[#f4efe6]">{state.email}</span></> : null}.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
            <Link to="/production" className="inline-flex items-center justify-center bg-[#00b8ff] text-black rounded-full px-8 py-4 font-semibold hover:bg-[#f4efe6] transition-colors duration-200" data-testid="thank-you-production-link">Explore Production</Link>
            <Link to="/work" className="inline-flex items-center justify-center border border-white/20 text-[#f4efe6] rounded-full px-8 py-4 font-semibold hover:border-[#00b8ff] transition-colors duration-200" data-testid="thank-you-work-link">See Our Work</Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
